import React, { useContext } from "react";

import styled from "styled-components/macro";

import { colors } from "UI/colors";

import { BoardContext } from "./BoardContext";

export default function TableEmptyMessage() {
  const [{ rows, filtersPanelOpen }] = useContext(BoardContext);
  const filters = window.fnReactBus.getCurrentFilterRequest();
  const hasFilters = filters && typeof filters === "object" && filters !== null;

  if (hasFilters && rows.length === 0) {
    return (
      <Wrapper filtersPanelOpen={filtersPanelOpen}>
        No one here matches that filter.
      </Wrapper>
    );
  }

  return null;
}

const Wrapper = styled.div`
  font-size: 24px;
  text-align: center;
  margin: 60px auto;
  padding-right: ${({ filtersPanelOpen }) =>
    filtersPanelOpen ? "320px" : null};
  font-weight: 300;
  color: ${colors.fnDkBlueGray};
`;
